import { GuestCommentOnRecipeMeta, GuestCommentOnRecipePayload } from 'types/store/GuestCommentOnRecipe';
import { createAsyncReducer } from 'utils/Redux';

import { guestCommentOnRecipeActions } from '../actions';

export default createAsyncReducer<GuestCommentOnRecipeMeta, GuestCommentOnRecipePayload>(guestCommentOnRecipeActions);
